/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-15 14:21:40
 *
 *******************************************************/

import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Stack } from '@shopify/polaris';
import { RenderRadioButtonItemV2 } from 'src/components/views/common/forms/render-radio-button-item-v2';
import { COLLECTION_HEADER_OPTIONS } from 'src/constants/theme-settings.js';

type Props = {
  formValues: any,
  prefix: string,
  updateField: (field: string, value: any) => void,
  collectionHeader: string,
  updateFieldReducer: (fieldName: string, data: any) => void
};

type ComposedProps = Props & WithI18nProps;

class CollectionHeaderTab extends Component<ComposedProps> {
  handleChangeCollectionHeader = (value: string) => {
    const { updateFieldReducer } = this.props;
    updateFieldReducer('collectionHeader', value);
  };

  render() {
    const { i18n, collectionHeader: selectedCollectionHeader } = this.props;

    const formattedCollectionHeaderOptions = COLLECTION_HEADER_OPTIONS.map((item, index) => {
      return {
        ...item,
        label: i18n.translate(item.label, {
          t: index + 1
        })
      };
    });

    return (
      <div className="form-section">
        <p>{i18n.translate('AdminHTML.ThemeSetting.LayoutModal.chooseLayout_ItemTitle')}</p>
        <div
          className="form-section__item form-section__item--medium-spacing"
          style={{ marginTop: '12px' }}>
          <div className="form-section__item" style={{ marginTop: '20px' }}>
            <Stack vertical spacing="loose">
              {formattedCollectionHeaderOptions.map((item, index) => {
                const Sample = item.sample;
                return (
                  <Stack.Item key={index}>
                    <RenderRadioButtonItemV2
                      id={item.value}
                      value={item.value}
                      input={{
                        name: 'collectionHeader',
                        value: selectedCollectionHeader,
                        onChange: this.handleChangeCollectionHeader
                      }}
                      label={item.label}
                      helpText={<Sample checked={selectedCollectionHeader === item.value} />}
                      keepNumericValue
                    />
                  </Stack.Item>
                );
              })}
            </Stack>
          </div>
        </div>
      </div>
    );
  }
}

export default withI18n()(CollectionHeaderTab);
